var module = angular.module('octopusApp.infrastructure');

module.directive("controlGroup", function ($timeout) {
  return {
    restrict: 'E',
    templateUrl: 'infrastructure/directives/views/control-group.html',
    replace: true,
    transclude: true,
    scope: {
      label: "@" // Gets the string contents of the `label` attribute.
    },
    link: function (scope, element) {

      scope.$watch('', function() {
        // The <label> should have a `for` attribute that links it to the input.
        // Get the `id` attribute from the input element
        // and add it to the scope so our template can access it.
        $timeout(function() {
          scope['for'] = element.find(":input, .form-control").attr("id");
        }, 100);
      });
    }
  };


});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/control-group.js
// module id = 654
// module chunks = 1